import React, { useEffect, useState } from 'react';
import './style.scss';
import fetcher from '../../../utils/fetcher';
import { AdminDataUnit, appToReact } from '../shared/configConverter';
import AdminDataSection from '../shared/dataBlock';
import Loader from '../../general/loader';
import clsx from 'clsx';

interface Props {
  handleAxiosError: (err: any) => any;
  className: string;
}

const ControlPanelStats = ({ handleAxiosError, className }: Props) => {
  const [loading, setLoading] = useState(true);
  const [stats, setStats] = useState<AdminDataUnit[]>([]);

  useEffect(() => {
    fetchStats();
    const interval = setInterval(() => fetchStats(), 5000);
    return () => clearInterval(interval);
  }, []);

  const fetchStats = () => {
    setLoading(true);
    fetcher.stats
      .get()
      .then((result) => {
        setStats(appToReact(result.stats, false));
      })
      .catch(handleAxiosError)
      .finally(() => setLoading(false));
  };

  return (
    <div className={className}>
      <div className='control-panel-stats-header'>
        <h2 className='cpsh-title'>Statistics</h2>
        <Loader
          size={30}
          className={clsx('cpsh-loader', loading && 'cpsh-loader-visible')}
        />
      </div>
      <AdminDataSection data={stats} handleChange={() => {}} simplified />
    </div>
  );
};

export default ControlPanelStats;
